<template>
  <div class="search-result" style="width: 100%">
    <v-card class="common-card grey lighten-4 title-search card-serach">
      <div class="ms-2 d-flex">
        <v-icon class="dark-icon">$BoxChecked</v-icon>
        <span class="mainFont--text ml-1"> نتیجه برای: </span>

        <span class="shopPrimary--text font-weight-bold">{{ search }}</span>
      </div>
      <span v-show="false">{{ reactivity }}</span>

      <div v-if="pageLoading" class="text-center">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="15"
          color="#7c4dff"
          class="mx-auto my-10"
        />
      </div>
      <div v-else class="mt-10">
        <v-row
          v-if="resultItems.items && !resultItems.items.length"
        >
         

          <v-col cols="12" xl="12" md="12" sm="12" xs="12" align="center">
            <div class="img-search">
              <img src="../../assets/images/search.svg" alt="" />
            </div>
          </v-col>
          <v-col cols="12" xl="12" md="12" sm="12" xs="12" align="center">
            <h5 class="mainFont--text fs-medium">نتیجه‌ای برای "{{ search }}" یافت نشد!</h5>
          </v-col>
        </v-row>
        <div v-else>
          <v-row>
            <v-col
              v-for="(item, index) in this.resultItems.items"
              :key="index"
              xl="2"
              lg="3"
              md="4"
              sm="4"
              xs="12"
              cols="12"
              class="text-center"
            >
              <store-item :item="item" :cart-id="cartId" />
            </v-col>
          </v-row>
          <div class="mt-6" v-if="this.resultItems.items">
            <v-pagination
              v-model="currentPage"
              :length="resultItems.totalPages"
              :total-visible="5"
              circle
              color="shopPrimary"
              @input="next()"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
import ProductCounter from "./../../components/OnlineShop/ProductCounter";
import { mapGetters, mapMutations } from "vuex";
import { HalfCircleSpinner, LoopingRhombusesSpinner } from "epic-spinners";
import { EventBus } from "./../../event-bus.js";
import StoreItem from "@/views/OnlineShop/StoreAll/Components/StoreItem";
export default {
  components: {
    StoreItem,
    LoopingRhombusesSpinner,
    ProductCounter,
    HalfCircleSpinner,
  },
  props: ["searchWord"],
  data() {
    return {
      cart: [],
      addLoading: [],
      resultItems: [],
      specialProducts: [],
      reactivity: false,
      disableLeft: false,
      disableRight: false,
      pageLoading: false,
      scrollLeftPrev: 0,
      search: "",
      cartId: "",
      currentPage: 1,
      perPage: 18,
    };
  },

  mounted() {
    EventBus.$on("doSearch", () => {
      this.search = this.$route.query.search;
      this.getData(1);
    });
    this.search = this.$route.query.search;
    // this.cart = localStorage.getItem("cart")
    //   ? JSON.parse(localStorage.getItem("cart"))
    //   : [];
    this.cartId = localStorage.getItem("cartId");

    this.getData(1);
   
  },

  methods: {
    handleAmount(event) {
      this.item.amountInCart = event;
    },
    ...mapMutations(["setInCart"]),
    // setInStorage() {
    //   this.setInCart(this.cart);
    //   localStorage.setItem("cart", JSON.stringify(this.cart));
    // },
    next() {
      this.getData(this.currentPage);
    },
    getData(page) {
      this.pageLoading = true;
      Axios.get(
        this.baseUrl +
          `/onlineShop/items/search?name=${this.search}&page=${page}`,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            this.resultItems = res.data;
            let container = document.getElementsByTagName("html")[0];
            container.scrollIntoView({ block: "start", behavior: "smooth" });
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.pageLoading = false;
       
          this.toast("Error: " + err.response.data, "error");
        });
    },
    addToCart(details) {
      if (localStorage.getItem("shopToken")) {
        this.loading = true;
        Axios.post(
          this.baseUrl + "/onlineShop/cart/addItem/" + this.cartId,
          {
            amount: 1,
            warehouseItemId: details.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("shopToken"),
            },
          }
        )
          .then((res) => {
            if (res.status === 200) {
              this.$store.dispatch("getCartData", {
                cartId: this.cartId,
                id: this.details.id,
              });
              this.toast(res.data.message, "success");
            } else {
              this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            }
            this.loading = false;
          })
          .catch((err) => {
            this.toast(err.response, "error");
          });
      } else {
        this.toast(
          "برای افزودن محصول به سبد خرید ابتدا ثبت نام یا ورود کنید",
          "error"
        );
      }
    },
    // addToCart(item, index) {
    //   this.addLoading[index] = true;
    //   this.reactivity = !this.reactivity;
    //   setTimeout(() => {
    //     item.amount = 1;
    //     this.cart.push(item);
    //     this.setInStorage();
    //     this.addLoading[index] = false;
    //     this.reactivity = !this.reactivity;
    //   }, 500);
    // },
    isInCart(item) {
      let index = this.cart.findIndex((x) => x.id == item.id);
      if (index > -1) {
        return true;
      } else return false;
    },
  },

  computed: {
    ...mapGetters(["cartItems"]),
    computedProductWidth() {
      if (this.specialProducts && this.specialProducts.length) {
        if (document.querySelector(".slider")) {
          if (window.screen.width < 1280) {
            return "240px";
          } else {
            let box = document.querySelector(".slider");
            return (box.getBoundingClientRect().width - 90) / 5 + "px";
          }
        }
        this.reactivity = !this.reactivity;
      }
    },
  },

  watch: {
    cartItems(val) {
      this.cart = val;
    },
    $route(to, from) {
      this.search = to.query.search;
      this.getData(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.img-search{
  width: 300px;
  height: auto;
  img{
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}
.title-search {
  span {
    font-size: 17px;
  }
}
.card-serach {
  padding: 25px;
}
.search-result {
  .common-card {
    min-height: calc(100vh - 255px);
  }

  .product-item-result {
    width: 100%;
    max-width: 240px;
    height: 420px;
    background-color: #fff;
    border-radius: 12px;
    .products-images {
      height: 262px;
      width: 100%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 12px 12px 0 0;
        aspect-ratio: 1 / 2;
      }
    }
  }
}
</style>
